// Announcement Bar Slider Initialization
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Slick to be loaded
  function initAnnouncementSlider() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      // If Slick isn't loaded yet, try again in 100ms
      setTimeout(initAnnouncementSlider, 100);
      return;
    }

    var $announcementSlider = jQuery('#AnnouncementSlider');
    
    if ($announcementSlider.length > 0) {
      // Only initialize if there's more than one slide
      if (parseInt($announcementSlider.attr('data-block-count')) > 1) {
        $announcementSlider.slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          pauseOnHover: true,
          fade: true,
          cssEase: 'linear'
        });
        
        console.log('Announcement slider initialized');
      }
    }
  }

  // Start the initialization process
  initAnnouncementSlider();
});
